import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { api } from '../api'

export const MENU_FAVORITES_QUERY_KEY = ['dashboard-menu-favorites']

async function fetchMenuFavorites() {
  const response = await api.get('/dashboard/menu-favorites', { __silent: true })
  const data = response?.data?.data
  return Array.isArray(data) ? data : []
}

export function useMenuFavoritesQuery(options = {}) {
  return useQuery({
    queryKey: MENU_FAVORITES_QUERY_KEY,
    queryFn: fetchMenuFavorites,
    staleTime: 30_000,
    ...options,
  })
}

export function useMenuFavoriteToggle() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async ({ item, favorite }) => {
      const menuItemId = encodeURIComponent(item.id)
      if (favorite) {
        await api.delete(`/dashboard/menu-favorites/items/${menuItemId}`, {
          __silent: true,
          params: { menuKey: item.menuKey },
        })
        return { favorite: false, item }
      }
      const response = await api.put(
        `/dashboard/menu-favorites/items/${menuItemId}`,
        { menuKey: item.menuKey },
        { __silent: true },
      )
      return { favorite: true, item, saved: response?.data?.data }
    },
    onSuccess: ({ favorite, item, saved }) => {
      queryClient.setQueryData(MENU_FAVORITES_QUERY_KEY, (current = []) => {
        const rows = Array.isArray(current) ? current : []
        const withoutItem = rows.filter((row) => row?.menuItemId !== item.id)
        if (!favorite) return withoutItem
        return [...withoutItem, saved || { menuItemId: item.id, menuKey: item.menuKey, sortOrder: rows.length }]
          .sort((a, b) => Number(a?.sortOrder || 0) - Number(b?.sortOrder || 0))
      })
    },
    onSettled: () => queryClient.invalidateQueries({ queryKey: MENU_FAVORITES_QUERY_KEY }),
  })
}
